module.exports = __webpack_public_path__ + "static/media/product-2021.b636d076.png";